import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Project } from '@shared/index';
import { ProjectService } from '../services/project.service';

export const projectResolver: ResolveFn<Project[]> = async (route) => {
  const projectService: ProjectService = inject(ProjectService);
  projectService.bots = [];
  projectService.selectedProject = undefined;
  projectService.searchString = '';
  const org = route.queryParamMap.get('org');
  if (org) projectService.searchOrgShort = org;
  await projectService.loadProjects();
  return projectService.projects;
};